import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/svgs/Logo_GreenRock.svg";
import { useDispatch, useSelector } from "react-redux";
import styles from "./layout.css";
import { logout } from "../store/slices/authSlice";
import { FiShoppingCart, FiUser } from "react-icons/fi";
import CartPanel from "../components/CartPanel/CartPanel";
import { useGetCartItemsQuery } from "../store/api/cartApi";
import EventBanner from "../components/EventBanner/EventBanner";
import { Popover } from "react-tiny-popover";
import { FaXmark } from "react-icons/fa6";
// import { refetchAllQueries } from "../store/refetchAllQueries";

const AppHeader = () => {
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const [porifleMenuOpen, setProfileMenuOpen] = useState(false);
  const [desktopporifleMenuOpen, setDesktopProfileMenuOpen] = useState(false);
  const [mobileProfile, setMobileProfile] = useState(false);
  const menuRef = useRef();
  const navigate = useNavigate();
  const buttonRef = useRef();
  const headerRef = useRef();
  const authData = useSelector((state) => state?.auth);
  const location = useLocation();
  const [cartOpen, setCartOpen] = useState(false);
  const { data: cartItem } = useGetCartItemsQuery(null, {
    skip: !authData?.token,
  });

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    // refetchAllQueries(dispatch);
  };
  useEffect(() => {
    if (!menuOpen) return;
    function handleClickOutside(e) {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  // Add scroll effect for blurry background
  useEffect(() => {
    const handleScroll = () => {
      if (!headerRef.current) return;
      if (window.scrollY > 10) {
        headerRef.current.classList.add("scrolled");
      } else {
        headerRef.current.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setProfileMenuOpen(false);
  }, [location]);

  return (
    <>
      {/*<EventBanner /> */}
      <header
        className={`nav-bar app-header${
          location.pathname === "/jck" ? " jck-header-dark" : ""
        }`}
        ref={headerRef}
      >
        <div className="nav-bar-left-sec">
          <div className="brand-logo">
            <Link to="/">
              <img src={logo} alt="Green Rock Logo" />
            </Link>
          </div>
          <button
            className={
              location.pathname === "/jck" ? `light-hamburger` : `hamburger`
            }
            aria-label="Open menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
            ref={buttonRef}
          >
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </button>
          <nav className={`nav-links ${menuOpen ? "open" : ""}`} ref={menuRef}>
            <div
              className={`nav-link${
                location.pathname === "/certified-diamonds" ? " active" : ""
              }`}
            >
              <Link to="/certified-diamonds">Certified Diamonds</Link>
            </div>
            <div
              className={`nav-link${
                location.pathname === "/about" ? " active" : ""
              }`}
            >
              <Link to="/about">About</Link>
            </div>

            <div
              className={`nav-link${
                location.pathname === "/blog" ? " active" : ""
              }`}
            >
              <Link to="/blog">Blog</Link>
            </div>
            {/* <div
              className={`nav-link${
                location.pathname === "/events" ? " active" : ""
              }`}
            >
              <Link to="/events">Event</Link>
            </div> */}

            <div
              className={`nav-link${
                location.pathname === "/contact" ? " active" : ""
              }`}
            >
              <Link to="/contact">Contact</Link>
            </div>
            {/* <div
              className={`nav-link${
                location.pathname === "/jck" ? " active" : ""
              }`}
            >
              <Link to="/jck">JCK</Link>
            </div> */}
            <div
              className={`mobile-profile-section  ${
                menuOpen ? "d-flex gap-2" : "d-none"
              }`}
            >
              <Popover
                isOpen={porifleMenuOpen}
                positions={["bottom"]}
                transform={{ top: 10, left: 70 }}
                transformMode="relative"
                align="end"
                padding={1}
                reposition={false}
                onClickOutside={() => setProfileMenuOpen(false)}
                content={({ position, nudgedLeft, nudgedTop }) => (
                  <>
                    {porifleMenuOpen && (
                      <div className="user-dropdown-menu" ref={menuRef}>
                        {authData?.userData ? (
                          <>
                            <Link
                              to="/profile"
                              className="user-dropdown-item"
                              onClick={() => setProfileMenuOpen(false)}
                            >
                              Profile
                            </Link>
                            <div
                              className="user-dropdown-item logout-item"
                              onClick={handleLogout}
                            >
                              Logout
                            </div>
                          </>
                        ) : (
                          <>
                            <Link
                              to="/login"
                              className="user-dropdown-item"
                              onClick={() => setProfileMenuOpen(false)}
                            >
                              Login
                            </Link>
                            <Link
                              to="/sign-up"
                              className="user-dropdown-item"
                              onClick={() => setProfileMenuOpen(false)}
                            >
                              Register
                            </Link>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
              >
                <div>
                  {authData?.userData ? (
                    <div className="user-section">
                      <button
                        className="userBtn"
                        onClick={() => setProfileMenuOpen((open) => !open)}
                      >
                        <FiUser className="userAvatar" size={24} />
                        <span className="userName">
                          {authData.userData.businessName}
                        </span>
                      </button>
                    </div>
                  ) : (
                    <button
                      className="nav-icon"
                      aria-label="User menu"
                      aria-haspopup="true"
                      aria-expanded={porifleMenuOpen}
                      onClick={() => setProfileMenuOpen((open) => !open)}
                      ref={buttonRef}
                    >
                      <FiUser className="userAvatar" size={24} />
                    </button>
                  )}{" "}
                </div>
              </Popover>
              <div className="nav-icon" onClick={() => setCartOpen(true)}>
                <div className="cart-item-count">{cartItem?.length}</div>
                <FiShoppingCart size={24} />
              </div>
            </div>
          </nav>
        </div>
        <div className="nav-bar-right-sec">
          <div className="profile">
            <Popover
              isOpen={desktopporifleMenuOpen}
              positions={["bottom"]}
              transform={{ top: 10, left: 70 }}
              transformMode="relative"
              align="end"
              padding={1}
              reposition={false}
              onClickOutside={() => setDesktopProfileMenuOpen(false)}
              content={({ position, nudgedLeft, nudgedTop }) => (
                <>
                  {desktopporifleMenuOpen && (
                    <div className="user-dropdown-menu" ref={menuRef}>
                      {authData?.userData ? (
                        <>
                          <Link
                            to="/profile"
                            className="user-dropdown-item"
                            onClick={() => setDesktopProfileMenuOpen(false)}
                          >
                            Profile
                          </Link>
                          <div
                            className="user-dropdown-item logout-item"
                            onClick={handleLogout}
                          >
                            Logout
                          </div>
                        </>
                      ) : (
                        <>
                          <Link
                            to="/login"
                            className="user-dropdown-item"
                            onClick={() => setDesktopProfileMenuOpen(false)}
                          >
                            Login
                          </Link>
                          <Link
                            to="/sign-up"
                            className="user-dropdown-item"
                            onClick={() => setProfileMenuOpen(false)}
                          >
                            Register
                          </Link>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            >
              <div>
                {authData?.userData ? (
                  <div className="user-section">
                    <button
                      className="userBtn"
                      onClick={() => setDesktopProfileMenuOpen((open) => !open)}
                    >
                      <FiUser className="userAvatar" size={24} />
                      <span
                        className={`userName ${
                          location.pathname === "/jck" ? "text-white" : ""
                        }`}
                      >
                        {authData.userData.businessName}
                      </span>
                    </button>
                  </div>
                ) : (
                  <button
                    className="nav-icon"
                    aria-label="User menu"
                    aria-haspopup="true"
                    aria-expanded={porifleMenuOpen}
                    onClick={() => setDesktopProfileMenuOpen((open) => !open)}
                    ref={buttonRef}
                  >
                    <FiUser className="userAvatar" size={24} />
                  </button>
                )}{" "}
              </div>
            </Popover>
          </div>
          <div className="nav-icon" onClick={() => setCartOpen(true)}>
            <div className="cart-item-count">{cartItem?.length}</div>
            <FiShoppingCart size={24} />
          </div>
        </div>
        <CartPanel open={cartOpen} onClose={() => setCartOpen(false)} />
      </header>
      <nav
        className={`nav-links nav-link-mobile ${menuOpen ? "open" : ""}`}
        ref={menuRef}
      >
        <div className="close-icon" onClick={() => setMenuOpen(false)}>
          <FaXmark />
        </div>
        <div
          className={`nav-link${
            location.pathname === "/certified-diamonds" ? " active" : ""
          }`}
        >
          <Link to="/certified-diamonds">Certified Diamonds</Link>
        </div>
        <div
          className={`nav-link${
            location.pathname === "/about" ? " active" : ""
          }`}
        >
          <Link to="/about">About</Link>
        </div>

        <div
          className={`nav-link${
            location.pathname === "/blog" ? " active" : ""
          }`}
        >
          <Link to="/blog">Blog</Link>
        </div>
        <div
          className={`nav-link${
            location.pathname === "/events" ? " active" : ""
          }`}
        >
          <Link to="/events">Event</Link>
        </div>

        <div
          className={`nav-link${
            location.pathname === "/contact" ? " active" : ""
          }`}
        >
          <Link to="/contact">Contact</Link>
        </div>
        <div
          className={`nav-link${location.pathname === "/jck" ? " active" : ""}`}
        >
          <Link to="/jck">JCK</Link>
        </div>
        <div
          className={`mobile-profile-section nav-link ${
            menuOpen ? "d-flex gap-2" : "d-none"
          }`}
        >
          <Popover
            isOpen={mobileProfile}
            positions={["bottom"]}
            align="end"
            padding={1}
            transformMode="relative"
            transform={{ top: 10, left: 70 }}
            onClickOutside={() => setMobileProfile(false)}
            content={({ position, nudgedLeft, nudgedTop }) => (
              <>
                {mobileProfile && (
                  <div className="user-dropdown-menu" ref={menuRef}>
                    {authData?.userData ? (
                      <>
                        <Link
                          to="/profile"
                          className="user-dropdown-item"
                          onClick={() => setMobileProfile(false)}
                        >
                          Profile
                        </Link>
                        <div
                          className="user-dropdown-item logout-item"
                          onClick={handleLogout}
                        >
                          Logout
                        </div>
                      </>
                    ) : (
                      <>
                        <Link
                          to="/login"
                          className="user-dropdown-item"
                          onClick={() => setMobileProfile(false)}
                        >
                          Login
                        </Link>
                        <Link
                          to="/sign-up"
                          className="user-dropdown-item"
                          onClick={() => setMobileProfile(false)}
                        >
                          Register
                        </Link>
                      </>
                    )}
                  </div>
                )}
              </>
            )}
          >
            <div>
              {authData?.userData ? (
                <div className="user-section">
                  <button
                    className="userBtn"
                    onClick={() => setMobileProfile((open) => !open)}
                  >
                    <FiUser className="userAvatar" size={24} />
                    <span className="userName">
                      {authData.userData.businessName}
                    </span>
                  </button>
                </div>
              ) : (
                <button
                  className="nav-icon"
                  aria-label="User menu"
                  aria-haspopup="true"
                  aria-expanded={mobileProfile}
                  onClick={() => setMobileProfile((open) => !open)}
                  ref={buttonRef}
                >
                  <FiUser className="userAvatar" size={24} />
                </button>
              )}{" "}
            </div>
          </Popover>
          <div
            className="nav-icon"
            onClick={() => {
              setCartOpen(true);
              setMenuOpen(false);
            }}
          >
            <div className="cart-item-count">{cartItem?.length}</div>
            <FiShoppingCart size={24} />
          </div>
        </div>
      </nav>
    </>
  );
};

export default AppHeader;
